import BreadcrumbsContainer from "./breadcrumbs-container";

export default BreadcrumbsContainer;
